import { useState, useEffect } from "react";

export function useLocalStorage(
  storageKey: string,
  fallbackState: string | null,
) {
  // Get the initial value from localStorage or use the fallback state
  const localStorageStr = localStorage.getItem(storageKey);

  const localStorageValue =
    localStorageStr !== null ? JSON.parse(localStorageStr) : fallbackState;

  const [value, setValue] = useState(localStorageValue);

  useEffect(() => {
    if (value) {
      // Update localStorage whenever the value changes
      localStorage.setItem(storageKey, JSON.stringify(value));
    }
  }, [value, setValue]);

  return [value, setValue];
}
